// --------------------------------------------------------
// DROP DOWN DESCRIPTION - DropDownDescription
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useState } from "react";
import {
  BodyContainerDropdownDescription,
  ContainerDropdownDescription,
  DropdownDescription,
} from "./DropdownDescription.styled";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// DROP DOWN DESCRIPTION INTERFACE
// --------------------------------------------------------

interface IDropDownDescription {
  title: string;
  description: string;
  onCLick: () => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const DropDownDescription = ({
  title,
  description,
  onCLick,
}: IDropDownDescription) => {
  // --------------------------------------------------------
  // DROP DOWN DESCRIPTION PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [isActive, setActive] = useState(false);

  const active = () => {
    setActive(!isActive);
    onCLick();
  };

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerDropdownDescription onClick={active}>
      <BodyContainerDropdownDescription isActive={isActive}>
        {title}
        {isActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </BodyContainerDropdownDescription>
      {isActive && (
        <DropdownDescription>
            {(description)}
        </DropdownDescription>
        )}
    </ContainerDropdownDescription>
  );
  // --------------------------------------------------------
};

export default DropDownDescription;
